import type {
  createPasswordBodyZod,
  CreatePasswordResponse,
} from "@nlc/shared-types";
import type { z } from "zod";

import { useMutation } from "@tanstack/react-query";

import { unauthenticatedApi } from "@/lib/api/client";

export function useCreatePasswordMutation() {
  return useMutation({
    mutationFn: async ({
      confirmPassword,
      password,
      token,
    }: z.infer<
      typeof createPasswordBodyZod
    >): Promise<CreatePasswordResponse> =>
      await unauthenticatedApi
        .url("/users/create-password")
        .post({ confirmPassword, password, token })
        .json(),
    mutationKey: ["create-password"],
  });
}
